import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private apiService: ApiService) { }

  private refresh$ = new Subject<void>();
  refreshObservable = this.refresh$.asObservable();

  public getUserList(state: any, data: any) {
    return this.apiService.apiPost('/users', data);
  }

  public triggerRefresh() {
    this.refresh$.next();
  }
}
